import * as ActionAuthorized from './athorization';
import * as ActionAdmin from './admin';
import * as ActionApp from './app';
import * as ActionBonusPersonalIssue from './bonus-personal-issue';
import * as ActionBonuses from './bonuses'
import * as ActionCashiersShift from './cashiersShift';
import * as ActionCashiersUsers from './cashiersUsers';
import * as ActionCredit from './credit';
import * as ActionExchangeRates from './exchangeRates';
import * as ActionFreespin from './freespin';
import * as ActionFreespinGame from './freespinGame';
import * as ActionGameReport from './game-report';
import * as ActionHistoryCredit from './history-credit';
import * as ActionInformationPanel from './information_panel';
import * as ActionJackpot from './jackpot';
import * as ActionKyc from './kyc';
import * as ActionLottery from './lottery';
import * as ActionMessanger from './messanger';
import * as ActionOrganization from './organization';
import * as ActionPaymentSystem from './paymentSystem';
import * as ActionPresentConfirmation from './presentConfirmation';
import * as ActionQiwi from './qiwi';
import * as ActionReferrals from './referrals';
import * as ActionReplenishment from './replenishment';
import * as ActionReportBalance from './report-balance';
import * as ActionReportBonuses from './report-bonuses';
import * as ActionReportDaily from './report-daily';
import * as ActionReportEvent from './report-event';
import * as ActionReportFinance from './report-finance';
import * as ActionReportGroup from './report-group';
import * as ActionReportJackpot from './report-jackpot';
import * as ActionReportProvider from './report-provider';
import * as ActionReportUnconfirmed from './report-unconfirmed';
import * as ActionSearchUser from './search-user';
import * as ActionSupport from './support';
import * as ActionTournament from './tournament';
import * as ActionUsers from './users';
import * as ActionWithdrawals from './withdrawals';
import * as ActionUserProfile from './user_profile';
import * as ActionCashiersMobile from './cashiersMobile';
import * as ActionComponentsMobile from './componentsMobile';
import * as ActionGamerMobile from './gamerMobile';
import * as ActionGamesMobile from './gamesMobile';
import * as ActionInformationPanelMobile from './informationPanelMobile';
import * as ActionJackpotMobile from './jackpotMobile';
import * as ActionKycMobile from './kycMobile';
import * as ActionPaymentMobile from './paymentMobile';
import * as ActionReplenishmentMobile from './replenishmentMobile';
import * as ActionReportMobile from './reportMobile';
import * as ActionSecurityMobile from './securityMobile';
import * as ActionSupportMobile from './supportMobile';
import * as ActionWithdrawalsMobile from './withdrawalsMobile';
import * as ActionPinsale from './pinsale';

export const Action = {
    Authorized: ActionAuthorized,
    Admin: ActionAdmin,
    App: ActionApp,
    BonusPersonalIssue: ActionBonusPersonalIssue,
    Bonuses: ActionBonuses,
    CashiersShift: ActionCashiersShift,
    CashiersUsers: ActionCashiersUsers,
    Credit: ActionCredit,
    ExchangeRates: ActionExchangeRates,
    Freespin: ActionFreespin,
    FreespinGame: ActionFreespinGame,
    GameReport: ActionGameReport,
    HistoryCredit: ActionHistoryCredit,
    InformationPanel: ActionInformationPanel,
    Jackpot: ActionJackpot,
    Kyc: ActionKyc,
    Lottery: ActionLottery,
    Messanger: ActionMessanger,
    Organization: ActionOrganization,
    PaymentSystem: ActionPaymentSystem,
    PresentConfirmation: ActionPresentConfirmation,
    Qiwi: ActionQiwi,
    Referrals: ActionReferrals,
    Replenishment: ActionReplenishment,
    ReportBalance: ActionReportBalance,
    ReportBonuses: ActionReportBonuses,
    ReportDaily: ActionReportDaily,
    ReportEvent: ActionReportEvent,
    ReportFinance: ActionReportFinance,
    ReportGroup: ActionReportGroup,
    ReportJackpot: ActionReportJackpot,
    ReportProvider: ActionReportProvider,
    ReportUnconfirmed: ActionReportUnconfirmed,
    SearchUser: ActionSearchUser,
    Support: ActionSupport,
    Tournament: ActionTournament,
    Users: ActionUsers,
    Withdrwals: ActionWithdrawals,
    UserProfile: ActionUserProfile,
    CashiersMobile: ActionCashiersMobile,
    ComponentsMobile: ActionComponentsMobile,
    GamerMobile: ActionGamerMobile,
    GamesMobile: ActionGamesMobile,
    InformationPanelMobile: ActionInformationPanelMobile,
    JackpotMobile: ActionJackpotMobile,
    KycMobile: ActionKycMobile,
    PaymentMobile: ActionPaymentMobile,
    ReplenishmentMobile: ActionReplenishmentMobile,
    ReportMobile: ActionReportMobile,
    SecurityMobile: ActionSecurityMobile,
    SupportMobile: ActionSupportMobile,
    WithdrawalsMobile: ActionWithdrawalsMobile,
    Pinsale: ActionPinsale
}